import { FunctionComponent, lazy, Suspense, useEffect, useMemo, useRef, } from "react";
import { CorpoTable, Tabela, TabelaCabeca, TabelaCorpo, Tabler } from "../../../../components/formulario/tableStyled";
import { useServicesEventosCheckin } from "../context/getServicesEventos";
import LoadingGif from "../../../../components/loading";

const Rows = lazy(() => import('./rows'));

interface TabelaListaEventosBatismoProps {

}

const TabelaListaEventosBatismo: FunctionComponent<TabelaListaEventosBatismoProps> = () => {

  const { listAll, nextPagina, pagina } = useServicesEventosCheckin()

  const devRef = useRef<HTMLDivElement>(null);

  useMemo(() => {
    listAll?.slice(0, ((pagina + 1) * 30))
  }, [pagina]);


  useEffect(() => {
    if (devRef.current) {
      devRef.current.addEventListener('scroll', (e: any) => {
        if (e.target?.scrollTop >= (e.target.scrollHeight - (e.target.clientHeight + 60))) {
          nextPagina()
        }
      })
    }
  }, [devRef])

  return (<>
    <Tabler>
      <Suspense fallback={<LoadingGif />}>
        <CorpoTable ref={devRef}>
          <Tabela>
            <>
              <TabelaCabeca>
                <tr>
                  {
                    ['Id', 'Sede', 'Evento', 'Cidade', 'Inicio', 'Termino', 'Ativo', 'Permite Inscrição?']?.map(
                      res => <th>{res}</th>
                    )
                  }
                  <th></th>
                </tr>
              </TabelaCabeca>
              <TabelaCorpo >
                <Rows />
              </TabelaCorpo>
            </>
          </Tabela>
        </CorpoTable>
      </Suspense>
    </Tabler>
  </>);
}

export default TabelaListaEventosBatismo;
